/* eslint-disable sonarjs/no-duplicate-string */
import { z } from "zod";
import { areaTypes, structuresPlace } from "@ac-expo/api-types";
import { fileSchema } from "../files/files.schema";
import {
  defaultAddressValues,
  requiredCoordsAddressSchema,
} from "../utils/address.schema";

export const upsertAreaSchema = z.object({
  id: z.string().optional(),
  arrayId: z.string(),
  name: z.string().min(2, "Veuillez entrer un nom"),
  type: z.enum(areaTypes),
  customType: z.string().optional(),
  surface: z.coerce.number().min(1, "Veuillez entrer une surface"),
  capacity: z.coerce.number().min(0, "Veuillez entrer une capacité"),
});

export type UpsertAreaForm = z.infer<typeof upsertAreaSchema>;

export const defaultUpsertAreaValues = {
  id: undefined,
  arrayId: "",
  name: "",
  type: "custom" as const,
  customType: "",
  surface: undefined,
  capacity: undefined,
};

export const upsertEntranceSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, "Veuillez entrer un nom"),
  address: requiredCoordsAddressSchema,
  city: z.string(),
  zipCode: z.string(),
  addressId: z.string().optional(),
  country: z.string().optional(),
});

export type UpsertEntranceForm = z.infer<typeof upsertEntranceSchema>;

export const defaultUpsertEntranceValues = {
  id: undefined,
  name: "",
  address: defaultAddressValues,
  city: "",
  zipCode: "",
  addressId: undefined,
  country: undefined,
};

export const upsertPlaceSchema = z.object({
  id: z.string().optional(),
  image: fileSchema.refine(({ key }) => key !== "", {
    message: "Veuillez sélectionner une image",
  }),
  name: z.string().min(2, "Veuillez entrer un nom"),
  description: z.string().min(2, "Veuillez entrer une description"),
  structure: z.enum(structuresPlace),
  surface: z.coerce.number().min(1, "Veuillez entrer une surface"),
  capacity: z.coerce.number().min(1, "Veuillez entrer une capacité"),
  venue: z
    .object({
      indoor: z.boolean(),
      outdoor: z.boolean(),
    })
    .refine((data) => data.indoor || data.outdoor, {
      message: "Au moins un type de lieu doit être renseigné",
    }),
  placeEntrances: z.array(upsertEntranceSchema),
  areas: z.array(upsertAreaSchema),
});

export type UpsertPlaceForm = z.infer<typeof upsertPlaceSchema>;

export const defaultUpsertPlaceValues = {
  id: undefined,
  image: {
    key: "",
    name: "",
    type: "media" as const,
  },
  name: "",
  description: "",
  structure: undefined,
  surface: undefined,
  capacity: undefined,
  venue: {
    indoor: false,
    outdoor: false,
  },
  placeEntrances: [],
  areas: [],
};
